import { ca } from '@cian/analytics';

import { type IPromo } from '../../../../types/promos';
import { type IPromoIdExtraObject, getProductsData } from '../../../../utils/getProductsData';

/**
 * @description Событие: показ списка спецпредложений (СОПР) на вкладке ипотечных офферов.
 */
export function trackPromoOffersShow(promos: IPromo[]): void {
  const promoId = promos.map<IPromoIdExtraObject>((promo, index) => ({
    position: index + 1,
    promo_id: parseInt(promo.uniquePromoId, 10),
    promo_type: promo.promoType,
  }));

  ca('eventSite', {
    action: 'show_sopr',
    category: 'Promo',
    label: 'mortgage_offers',
    name: 'oldevent',
    products: [getProductsData({ promoId })],
  });
}
